import { userDevices } from "../api/apis"
export default {
    setParameter(ctx, email) {
        userDevices({ email: email }).then(res => {
            if (res.data) {
                ctx.commit('setData', res.data)
            }
        })
    }
}